<!-- app.component.html (or wherever you host router‐outlet + footer) -->
<div class="app-container">
  <!-- optional language toggle -->
  <!-- <div class="language-flag-toggle">…</div> -->

  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>

  <app-footer></app-footer>
</div>
